<template>
<gkFormText
  class="cellphone-text"
  ref="cellphone"
  validity
  :group="group"
  :field="field"
  :trigger="trigger"
  type="text"
  :size="size"
  :color="color"
  :placeholder="placeholder"
  :length="length"
  :rule="mergeRule"
  :disabled="disabled"
  :customRule="customRule"
  v-model="currentValue"
  @input="$emit('input', $event)"
  @blur="$emit('blur', $event)"
  @focus="$emit('focus', $event)"
>
  <gkSelectV2
    slot="pre"
    field="country"
    class="country-select"
    :size="size"
    color="base"
    :placeholder="placeholder"
    :options="options"
    :offset="6"
    v-if="options.length"
    v-model="country"
    rule="required"
    @input="handleChooseCountry"
  >
    <template slot="label">
      + {{country}}
    </template>
    <template slot="option" slot-scope="{option}">
      <span class="cn">{{option.cn}}</span>
      <span class="country">{{option.label}}</span>
    </template>
    <!-- <Icon slot="end" class="select-arrow" slot-scope="{focused}" :code="focused ? '&#xe68b;' : '&#xe68a;'" :focused="focused" gk-select-icon-arrow /> -->
    <!-- <Icon slot="end" class="select-arrow" slot-scope="{focused}" code="&#xe68a;" :focused="focused" gk-select-icon-arrow /> -->
  </gkSelectV2>
</gkFormText>
</template>

<script>
import VueTypes from 'vue-types'
// import {mapActions, mapState} from 'vuex'

import gkFormText from 'gkui/form/FormText'
import gkSelectV2 from 'gkuiV2/select'
import formProps from 'gkui/form/form.props'
import validityProps from 'gkui/form/validity.props'
import ConfigService from '../../service/config.service'

// import Icon from '../Icon'

export default {
  name: 'cellphone',
  components: {
    gkSelectV2,
    gkFormText
    // Icon
  },
  props: Object.assign({}, formProps, validityProps, {
    useCountry: VueTypes.bool.def(true),
    field: VueTypes.string.def('cellphone'),
    placeholder: VueTypes.string.def('手机号'),
    rule: VueTypes.oneOfType([String, Array]).def(['required'])
  }),
  data () {
    return {
      options: [],
      country: 86,
      currentValue: this.value
    }
  },
  computed: {
    cnLabel () {
      let cur = this.options.find(item => item.value === this.country)
      return cur.cn
    },
    mergeRule () {
      const rules = ['required'].concat(this.rule)

      if (this.country === 86) {
        rules.push({
          'mobile': '手机号格式错误'
        })
      } else {
        rules.push({
          'specialMobile': '手机号格式错误'
        })
      }

      return rules.map(item => {
        if (item === 'required') {
          return {
            required: '请输入手机号'
          }
        }

        return item
      })
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    }
  },
  created () {
    if (this.useCountry) {
      ConfigService.getPhoneList().then(res => {
        this.options = res.map(option => {
          return {
            value: option.code - 0,
            label: `+${option.code}`,
            cn: option.cn
          }
        })
      })
    }
  },
  methods: {
    // ...mapState(['phoneList']),
    // ...mapActions([
    //   'getPhoneList'
    // ]),
    handleChooseCountry (val) {
      this.$emit('country', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.cellphone-text {
  // height: 42px;
  // margin-bottom: 32px;

  // @include mobile () {
  //   margin-bottom: 22px;
  // }

  &.gkui-form-element[gktext-color="underline"] ::v-deep .gkui-form-text {
    padding-left: 17px;
  }
}
//

.country-select {
  height: 100%;
  padding: 0; margin: 0 -4px 0 0;
  border: none;

  @include mobile {
    height: auto;
    margin: 1px 8px 1px 0;

    &:before {
      display: none;
    }
  }

  &:after {
    content: '';
    display: block;
    position: absolute; right: 0; top: 50%;
    width: 1px; height: 13px;
    margin-top: -7px;
    background: #EFF0F2;

    @include mobile {
      // top: 10px;
      // height: 22px;
      background: #E5E5E5;
    }
  }

  & ::v-deep {
    & [gk-select-popup] {
      box-sizing: content-box;
      top: 44px!important;
      width: 341px!important;

      @include mobile () {
        width: 261px!important;
      }
    }

    & [gk-select-label] {
      position: relative;
      // padding: 0 35px 0 14px;
      padding-right: 34px;
      @include font(16, 400);
      color: $gray;

      &:before,
      &:after {
        content: '';
        position: absolute; right: 17px;
        width: 0; height: 0;
        border: 3px solid #fff;
      }

      &:before {
        top: 12px;
        border-bottom-color: $gray;
      }

      &:after {
        bottom: 12px;
        border-top-color: $gray;
      }

      @include mobile {
        // padding: 0 37px 0 2px;
      }
    }
    & [gk-select-option] {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      &[selected] {
        background: #F8F9FA;
        &:after {
          content: '';
        }
      }
    }

    & [gkselect-scrollbar] {
      height: 182px;

      // todo 没有选择器，所以暂时直接用 div 标签
      & > div {
        border-radius: 5px;
      }
    }
  }
}
.select-arrow {
  position: absolute; right: 6px; top: 16px;
  display: block;
  line-height: 1;
  font-size: 12px;
  color: #C0C0C0;
  transform: scale(0.5);
  pointer-events: none;

  &[focused] {
    font-size: 12px;
    color: $blue;
    transform: scale(0.5) translateY(0px) rotate(180deg);
  }

  @include mobile {
    top: 15px;
  }
}

// @media (max-width: 768px) {
//   .country-select {
    // height: auto;
    // margin: 1px 8px 1px 0;

    // &:before {
    //   display: none;
    // }

    // &:after {
    //   content: '';
    //   display: block;
    //   position: absolute; right: 0; top: 11px;
    //   width: 1px; height: 22px;
    //   background: #E5E5E5;
    // }

  //   & ::v-deep {
  //     & [gk-select-label] {
  //       padding: 0 37px 0 2px;
  //     }

  //     & [gkselect-scrollbar] {
  //       height: 182px;
  //     }
  //   }
  // }
  // .select-arrow {
  //   position: absolute; right: 8px; top: 14px;
  //   display: block;
  //   line-height: 1;
  //   font-size: 15px;
  //   color: #C0C0C0;
  //   transform: scale(0.5);
  //   pointer-events: none;

  //   &[focused] {
  //     font-size: 14px;
  //     color: $blue;
  //   }
  // }
// }
</style>
